Object.defineProperty(exports,"__esModule",{value:true});exports.victoryInterpolator=exports.interpolateObject=exports.interpolateFunction=exports.interpolateImmediate=exports.isInterpolatable=undefined;var _isPlainObject2=require("lodash/isPlainObject");var _isPlainObject3=_interopRequireDefault(_isPlainObject2);var _d3Interpolate=require("d3-interpolate");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}


var isInterpolatable=exports.isInterpolatable=function isInterpolatable(obj){

if(obj!==null){
switch(typeof obj){
case"undefined":
return false;
case"number":


return!isNaN(obj)&&obj!==Number.POSITIVE_INFINITY&&obj!==Number.NEGATIVE_INFINITY;
case"string":


return true;
case"boolean":



return false;
case"object":

return obj instanceof Date||Array.isArray(obj)||(0,_isPlainObject3.default)(obj);
case"function":










return true;}

}
return false;
};
















var interpolateImmediate=exports.interpolateImmediate=function interpolateImmediate(a,b){var when=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;
return function(t){
return t<when?a:b;
};
};













var interpolateFunction=exports.interpolateFunction=function interpolateFunction(a,b){
return function(t){
if(t>=1){
return b;
}
return function(){

var aval=typeof a==="function"?a.apply(this,arguments):a;
var bval=typeof b==="function"?b.apply(this,arguments):b;
return(0,_d3Interpolate.interpolate)(aval,bval)(t);
};
};
};











var interpolateObject=exports.interpolateObject=function interpolateObject(a,b){
var interpolateTypes=function interpolateTypes(x,y){
if(x===y||!isInterpolatable(x)||!isInterpolatable(y)){
return interpolateImmediate(x,y);
}
if(typeof x==="function"||typeof y==="function"){
return interpolateFunction(x,y);
}
if(typeof x==="object"&&(0,_isPlainObject3.default)(x)||typeof y==="object"&&(0,_isPlainObject3.default)(y)){
return interpolateObject(x,y);
}
return(0,_d3Interpolate.interpolate)(x,y);
};

var i={};
var c={};
var k=void 0;

if(a===null||typeof a!=="object"){
a={};
}
if(b===null||typeof b!=="object"){
b={};
}

for(k in b){
if(k in a){
i[k]=interpolateTypes(a[k],b[k]);
}else{
c[k]=b[k];
}
}

return function(t){
for(k in i){
c[k]=i[k](t);
}
return c;
};
};

























var victoryInterpolator=exports.victoryInterpolator=function victoryInterpolator(a,b){



if(a===b||!isInterpolatable(a)||!isInterpolatable(b)){
return interpolateImmediate(a,b);
}
if(typeof a==="function"||typeof b==="function"){
return interpolateFunction(a,b);
}
if((0,_isPlainObject3.default)(a)||(0,_isPlainObject3.default)(b)){
return interpolateObject(a,b);
}
return(0,_d3Interpolate.interpolate)(a,b);
};


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-animation/util.js
// module id = 1370
// module chunks = 0